const dataQaIdAttribute = 'data-qa-id';
const dataQaStateAttribute = 'data-qa-state';

export enum QaTestingElements {
  ContinueButton = 'continue-button',
  BackButton = 'back-button',

  // Card
  CardHolderName = 'cc-name',
  CardNumber = 'cc-number',
  CardExpiry = 'cc-expiration',
  CardCCV = 'cc-cvv',
  CardField = 'card-field',

  // Methods
  ApplyPayButton = 'apple-pay-btn',
  GooglePayButton = 'google-pay-btn',
  PaypalPayButton = 'paypal-pay-btn',
  PaypalPayLaterButton = 'paypal-paylater-pay-btn',

  // Bank
  AccountHolderName = 'account-holder-name',
  AccountIban = 'account-iban',
  AccountBankName = 'account-bank-name',
}

export function getQaTestingProps(
  element: QaTestingElements | string,
  state?: string | number,
): Record<string, string> {
  const testingAttributes: Record<string, string> = {
    [dataQaIdAttribute]: element,
  };

  if (state) {
    testingAttributes[dataQaStateAttribute] = state.toString();
  }

  return testingAttributes;
}

export interface ITestableElement {
  readonly qaTestingId: QaTestingElements | string;
}
